<!-- Contact Component -->
<script>
  import { Col, Row, Container, FormGroup, Input } from "sveltestrap";
</script>

<!-- CONTACT FORM START-->
<section class="section common-section" id="contact">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">Contáctanos</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          Para solicitar m&aacute;s informaci&oacute;n sobre la Pltaforma Conecta a trav&eacute;s del Consejo General de Colegios de Administradores de Fincas de España.
        </p>
      </Col>
    </Row>
    <Row>
      <Col lg="4">
        <div class="mt-4 pt-4">
          <p class="mt-4">
            <span class="h5">Direcci&oacute;n:</span><br />
            <span class="text-muted d-block mt-2"
              >Plaza Marqués de Salamanca, 10 3º Izda.<br />28006 Madrid</span
            >
          </p>
          <p class="mt-4">
            <span class="h5">Tel&eacute;fonos:</span><br />
            <span class="text-muted d-block mt-2"
              >+34 91 575 73 69 <br />+34 91 576 92 17</span
            >
          </p>
        </div>
      </Col>
      <Col lg="8">
        <img src="images/svg/Fondo_Conecta.svg" alt="Fondo Conecta"/>
      </Col>
    </Row>
  </Container>
</section>
<!-- CONTACT FORM END-->
